import React from 'react';
import Overlay from '../Overlay/Overlay';
import { toggleOverlay } from '../../Slices/OverlaySlice';
import { useDispatch } from 'react-redux';

const PriceHistoryContainer = (props) => {
  const dispatch = useDispatch();
  const { previouslyLowestPrice, title, description } = props;
  return (
    previouslyLowestPrice && (
      <>
        <button
          className="price-history-container__button"
          onClick={() => dispatch(toggleOverlay('product-price-history'))}
        >
          <div className="icon-info"></div>
        </button>
        <Overlay id="product-price-history">
          <div className="price-history-container__content">
            <h5 className="price-history-title">{title}</h5>
            <h4 className="price-history-title">{previouslyLowestPrice}</h4>
            <div className="price-history-container__text">
              <p>{description}</p>
            </div>
          </div>
        </Overlay>
      </>
    )
  );
};

export default PriceHistoryContainer;
